/**
 * Per-user Market filters. Explicit query param always wins;
 * saved preference only fills the gap. Empty `country=` means all countries.
 */

export const EMPTY_FILTER_KEYS = new Set(['country', 'lms']);

export function countryToQueryParam(countryFilter) {
  if (countryFilter == null || countryFilter === 'all') return '';
  return String(countryFilter);
}

export function lmsToQueryParam(lmsVendors) {
  if (!Array.isArray(lmsVendors) || lmsVendors.length === 0) return '';
  return lmsVendors.filter(Boolean).join(',');
}

export function parseLmsQueryParam(raw) {
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  if (!trimmed) return [];
  return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
}

/**
 * URL / saved-pref merge.
 * `urlValue` is null when the key is absent; '' when present-and-empty.
 */
export function resolveFilterValue(urlValue, savedList, { emptyMeansAll = true } = {}) {
  if (urlValue !== null && urlValue !== undefined) {
    if (emptyMeansAll && urlValue === '') return emptyMeansAllValue();
    return urlValue;
  }
  const saved = Array.isArray(savedList) ? savedList.filter(Boolean) : [];
  if (!saved.length) return emptyMeansAllValue();
  return saved;
}

function emptyMeansAllValue() {
  return [];
}

export function resolveCountryFilter(urlCountry, savedCountries) {
  if (urlCountry !== null && urlCountry !== undefined) {
    return urlCountry === '' ? 'all' : urlCountry;
  }
  const saved = Array.isArray(savedCountries) ? savedCountries.filter(Boolean) : [];
  return saved[0] || 'all';
}

export function countriesPayload(countryFilter) {
  if (!countryFilter || countryFilter === 'all') return [];
  return [countryFilter];
}
